import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { FormControlLabel, Radio, Tooltip } from '@mui/material'
import { LabelWithIndicator } from '@carto/meridian-ds/components'

function EntireOrganizationOption({
  disabled,
  tooltip,
  labelWithIndicatorIcon
}: {
  disabled?: boolean
  tooltip?: ReactNode
  labelWithIndicatorIcon?: ReactNode
}) {
  return (
    <Tooltip title={disabled && tooltip}>
      <FormControlLabel
        value="organization"
        disabled={disabled}
        control={<Radio disabled={disabled} />}
        label={
          <LabelWithIndicator
            label={<FormattedMessage id={'common.shareDialog.sharingMode.all'} />}
            icon={labelWithIndicatorIcon}
          />
        }
      />
    </Tooltip>
  )
}

export default EntireOrganizationOption
